import React, { useState, useRef, useEffect } from 'react';
import './DualRangeSlider.css';

const DualRangeSlider = ({ min, max, step, valueMin, valueMax, onChange, formatValue }) => {
  const [minVal, setMinVal] = useState(valueMin || min);
  const [maxVal, setMaxVal] = useState(valueMax || max);
  const minValRef = useRef(null);
  const maxValRef = useRef(null);
  const rangeRef = useRef(null);

  useEffect(() => {
    setMinVal(valueMin || min);
    setMaxVal(valueMax || max);
  }, [valueMin, valueMax, min, max]);

  // Atualizar range quando valores mudam
  useEffect(() => {
    const minPercent = Math.round(((minVal - min) / (max - min)) * 100);
    const maxPercent = Math.round(((maxVal - min) / (max - min)) * 100);

    if (rangeRef.current) {
      rangeRef.current.style.left = `${minPercent}%`;
      rangeRef.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, maxVal, min, max]);

  const handleMinChange = (e) => {
    const value = Math.min(+e.target.value, maxVal - step);
    const newMinVal = Math.max(value, min);
    setMinVal(newMinVal);
    onChange({ min: newMinVal, max: maxVal });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(+e.target.value, minVal + step);
    const newMaxVal = Math.min(value, max);
    setMaxVal(newMaxVal);
    onChange({ min: minVal, max: newMaxVal });
  };

  return (
    <div className="dual-range-container">
      <div className="dual-range-wrapper">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={minVal}
          ref={minValRef}
          onChange={handleMinChange}
          className="dual-range-input dual-range-input-min"
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={maxVal}
          ref={maxValRef}
          onChange={handleMaxChange}
          className="dual-range-input dual-range-input-max"
        />
        <div className="dual-range-track">
          <div className="dual-range-range" ref={rangeRef} />
        </div>
      </div>
      <div className="dual-range-values">
        <span>{formatValue ? formatValue(minVal) : minVal}</span>
        <span>{formatValue ? formatValue(maxVal) : maxVal}</span>
      </div>
    </div>
  );
};

export default DualRangeSlider;

